import { Add } from "@material-ui/icons";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { setDialogHandle } from "../../actions/dialog";
import NoVenueImageIcon from '../../assets/images/NoVenueImageIcon';
import VenueImporterDialog from '../modal/VenueImporterDialog';
import { useStyles } from './VenueViewCard';

const VenueViewImportButton = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const importLocations = () => {
        dispatch(
            setDialogHandle({
                Component: VenueImporterDialog,
                ComponentProps: {
                },
                dialogTitle: t("venueSelection.title"),
                isFormDialog:false
            })
        )
    }

    return (
        <div data-component-name="VenueViewCard" style={{flexDirection:"row"}}  className={classes.root} onClick={importLocations} key={Math.random()} >
            <div className={`${classes.icon} ${classes.iconVenue}`}>
                <NoVenueImageIcon />
            </div>
            <div className={classes.content}>
                {t("venueSelection.importVenue")}
            </div>
            <div className={`${classes.icon} ${classes.iconAdd}`}>
                <Add />
            </div>
        </div>
    )
}

export default VenueViewImportButton;